module.exports = __webpack_public_path__ + "img/img-box-1.099e629f.png";